export default __webpack_public_path__ + "static/media/token-mobi.4bd08103.svg";